import { memo, useEffect, useState } from "react";

// Helpers
import { useTranslate } from "helpers";

// Types
import { VehicleContractRentContentProps } from "./types";
import { Dropdown } from "ui/components/Dropdown/Dropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import { useHandleDropdownChange } from "services/forms/hooks";
import { DataWithPagination } from "services/api";

import { initialDataWithPagination } from "services/api/consts";
import { Pagination } from "services/search";

import { getContractRentTemplatesAPI } from "services/api/settings/documents/api";
import { ContractRentTemplateRow } from "services/api/settings/documents/types";



const VehicleContractRentContent: React.FC<VehicleContractRentContentProps> = ({
  formValues,
  setFormValues,
  errors,
  setErrors
}) => {
  const { t } = useTranslate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [searchResults, setSearchResults] = useState<DataWithPagination<ContractRentTemplateRow>>(initialDataWithPagination);

  useEffect(() => {
    let isMounted = true;

    const loadData = async () => {
      if (isMounted) {
        await fetchSearchResult(searchResults.pagination);
      }
    };

    loadData();

    return () => {
      isMounted = false;
    };
  }, []);

  const fetchSearchResult = async (
    pagination: Pagination,
  ) => {
    setIsLoading(true);
    try {
      const results = await getContractRentTemplatesAPI(pagination);
      setSearchResults(results);
    } catch (error: any) {
      // Handle 404 - endpoint not found
      if (error?.response?.status === 404) {
        console.warn("Contract templates endpoint not available (404). This feature may not be implemented yet.");
      }
      setSearchResults(initialDataWithPagination);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (
      searchResults.data.length > 0 &&
      !formValues.contractRentTemplateId
    ) {
      setFormValues((prev) => ({
        ...prev,
        contractRentTemplateId: searchResults.data[0].id,
      }));
    }
  }, [searchResults.data]);



  const contractRentTemplates: DropdownOption[] = searchResults?.data?.map((i) => {
    return {
      value: i.id,
      text: i.name,
    };
  });

  const handleDropdownChange = useHandleDropdownChange(
    setFormValues,
    formValues
  );


  return (
    <>
      <div className="flex gap-3 mb-3">
        <div className="flex-1">
          <Dropdown
            name="contractRentTemplateId"
            label={t("admin.fleet.vehicle.contract.add.tab.content.templateid")}
            placeholder={t("admin.fleet.vehicle.contract.add.tab.content.templateid.placeholder")}
            options={contractRentTemplates}
            value={formValues.contractRentTemplateId}
            onChange={handleDropdownChange}
            required
            error={errors.contractRentTemplateId}
          />
        </div>

      </div>
    </>
  );
};

export default memo(VehicleContractRentContent);
